import { isRecentlyLaunched } from '@/entities/catalog-item';
import { Tag } from '@/shared/ui';

/**
 * Renders the catalog "NEW" badge when a code was launched within the last 90
 * days. Renders nothing otherwise. `now` is injectable for deterministic tests.
 */
export const LaunchBadge = ({
  launchDate,
  now = new Date()
}: {
  launchDate?: string;
  now?: Date;
}) =>
  isRecentlyLaunched(launchDate, now) ? (
    <Tag
      label='NEW'
      tone='new'
    />
  ) : null;
